<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="mkt-ops -main-font bookprice-dialog-filter-product"
      :md-click-outside-to-close="false"
    >
      <div
        style="position: absolute;top: 50%; left: 66%; width: 10%; z-index: 2;"
        v-show="loading == true"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>

      <md-dialog-title>Add Filters</md-dialog-title>

      <div class="dialog-content">
        <div class="md-layout">
          <!-- LEFT PANEL -->
          <div class="left-panel">
            <div
              class="md-layout-item md-size-100"
              style="font-weight: bold; font-size: 14px; color: #727272; margin-bottom: 12px;"
            >
              Product by
            </div>

            <!-- <div
              class="md-layout-item md-size-100"
              style="font-size: 14px; color: #727272; display: flex;"
            >
              <md-checkbox
                v-model="checkedItemBookPrice"
                class="md-primary"
                style="margin: 12px 12px 12px 0;"
                >Item ที่ผูก Book Price</md-checkbox
              >
            </div> -->

            <div class="md-layout-item md-size-100 mb10">
              <multiselect
                v-model="selectedProoductType"
                id="type"
                label="title"
                track-by="code"
                placeholder="Search Type"
                :open-direction="'bottom'"
                :options="optionsProoductType"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div>{{ option.code }} - {{ option.title }}</div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'type')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>

            <div class="md-layout-item md-size-100 mb10">
              <multiselect
                v-model="selectedProoductGroup"
                id="group"
                label="title"
                track-by="code"
                placeholder="Search Group"
                :open-direction="'bottom'"
                :options="optionsProoductGroup"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div>{{ option.code }} - {{ option.title }}</div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'group')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>

            <div class="md-layout-item md-size-100 mb10">
              <multiselect
                v-model="selectedProoductSubGroup"
                id="subgroup"
                label="title"
                track-by="code"
                placeholder="Search Sub Group"
                :open-direction="'bottom'"
                :options="optionsProoductSubGroup"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div>{{ option.code }} - {{ option.title }}</div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="
                        clearAll(option.code, 'subgroup')
                      "
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>

            <div class="md-layout-item md-size-100 mb10">
              <multiselect
                v-model="selectedProoductCG"
                id="cg"
                label="title"
                track-by="code"
                placeholder="Search CG"
                :open-direction="'bottom'"
                :options="optionsProoductCG"
                :searchable="true"
                :max-height="180"
                :show-no-results="false"
                :custom-label="customLabelProoduct"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
                :hide-selected="true"
                @select="setDataProoduct"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <div>{{ option.code }} - {{ option.title }}</div>
                    <div
                      class="-delete"
                      @mousedown.prevent.stop="clearAll(option.code, 'cg')"
                    >
                      <i class="material-icons">close</i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>

            <div
              class="md-layout-item md-size-100 mb10"
              style="margin-top: 15px;"
            >
              <div class="custom-input-search">
                <md-field class="md-search-box">
                  <md-icon>search</md-icon>
                  <md-input
                    type="text"
                    placeholder="Search product code"
                    v-model="searchProductCode"
                  ></md-input>
                </md-field>
              </div>
            </div>
            <div
              class="md-layout-item md-size-100 mb10"
              style="margin-top: 15px;"
            >
              <div class="custom-input-search">
                <md-field class="md-search-box">
                  <md-icon>search</md-icon>
                  <md-input
                    type="text"
                    placeholder="Search product name"
                    v-model="searchProductName"
                  ></md-input>
                </md-field>
              </div>
            </div>

            <div
              class="md-layout-item md-size-100"
              style="margin-top: 22px; text-align: center;"
            >
              <md-button
                class="md-raised md-primary filter-search"
                @click="searchProduct()"
                >SEARCH</md-button
              >
            </div>
          </div>

          <!-- RIGHT PANEL -->
          <div class="right-panel">
            <div
              class="md-layout-item md-size-100"
              style="font-weight: bold; font-size: 14px; color: #727272; margin-bottom: 5px; padding-left: 5px;"
            >
              Product List
            </div>

            <!-- TABLE -->
            <div class="md-layout-item md-size-100 table-filter-product">
              <!-- HEAD -->
              <div class="divHeadList">
                <div style="width: 6%;">
                  <label class="-mkt-checkbox-container">
                    <input
                      type="checkbox"
                      v-model="checkedProductAll"
                      @click="selectedCheckedAllProduct()"
                    />
                    <span class="-mkt-checkbox"></span>
                  </label>
                </div>
                <div style="width: 14%;">Code</div>
                <div style="width: 80%;">Itme Name</div>
              </div>

              <!-- BODY -->
              <div class="divBodyList">
                <div
                  v-show="tableFilterProduct.length === 0"
                  :class="'row-bg-gray'"
                  style="display: block; text-align: center; font-size: 14px;"
                >
                  No data in table.
                </div>
                <div
                  :class="'row-bg-gray'"
                  v-for="(item, rIndex) in tableFilterProduct"
                  :key="rIndex"
                >
                  <div style="width: 6%;">
                    <label class="-mkt-checkbox-container">
                      <input
                        type="checkbox"
                        v-model="checkedProduct"
                        :value="item.code"
                        @click="selectedCheckedProduct(item.code)"
                      />
                      <span class="-mkt-checkbox"></span>
                    </label>
                  </div>
                  <div style="width: 14%;">{{ item.code }}</div>
                  <div
                    style="width: 80%;"
                    :title="item.item_name"
                    class="nowrap-title -font-kanit"
                  >
                    {{ item.item_name }}
                  </div>
                </div>
              </div>

              <!-- FOOTER -->
              <div class="footer-table">
                number of lines in page ({{ tableFilterProduct.length }})
              </div>
            </div>
          </div>
        </div>
      </div>

      <md-dialog-actions>
        <div class="md-layout" style="width: 100%;">
          <div class="md-layout-item md-size-100" style="text-align: right;">
            <md-button class="-cancel" @click="onClickCancel()"
              >CLOSE</md-button
            >
            <md-button class="-confirm" @click="onClickAdd()">ADD</md-button>
            <md-button class="-confirm" @click="onClickAddClose()"
              >ADD & CLOSE</md-button
            >
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>
  </div>
</template>

<script>
import BookpriceService from "@/services/bookprice";
import DialogConfirm from "./../../shared/dialog-confirm";

export default {
  name: "dialog-filter-product",

  components: {
    DialogConfirm
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    bookpriceGroup: {
      type: String,
      required: true
    },
    groupBookCode: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      checkEvent: "",
      bookpricegroup: "",
      groupbookcode: "",
      checkedItemBookPrice: false,
      selectedProoductType: [],
      optionsProoductType: [],
      selectedProoductGroup: [],
      optionsProoductGroup: [],
      selectedProoductSubGroup: [],
      optionsProoductSubGroup: [],
      selectedProoductCG: [],
      optionsProoductCG: [],
      searchProductCode: "",
      searchProductName: "",
      tableFilterProduct: [],
      checkedProductAll: false,
      checkedProduct: [],
      dataToken: {},
      loading: false
    };
  },

  watch: {
    show() {
      if (this.show) {
        this.dataToken = this.$jwt.decode(localStorage.getItem("token"));
        this.bookpricegroup = this.bookpriceGroup;
        this.groupbookcode = this.groupBookCode;
        this.getAllProduct();
      }
    }
  },

  methods: {
    getAllProduct(datas) {
      BookpriceService.getAllProduct(datas)
        .then(response => {
          if (response) {
            this.optionsProoductType =
              response.data.type !== undefined
                ? response.data.type.sort((a, b) => (a.code > b.code ? 1 : -1))
                : [];
            this.optionsProoductGroup =
              response.data.product_group !== undefined
                ? response.data.product_group.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];
            this.optionsProoductSubGroup =
              response.data.product_subgroup !== undefined
                ? response.data.product_subgroup.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];
            this.optionsProoductCG =
              response.data.product_cg !== undefined
                ? response.data.product_cg.sort((a, b) =>
                    a.code > b.code ? 1 : -1
                  )
                : [];

            if (datas !== undefined && datas.type == "group") {
              this.selectedProoductType = response.data.type[0];
            } else if (datas !== undefined && datas.type == "subgroup") {
              this.selectedProoductType = response.data.type[0];
              this.selectedProoductGroup = response.data.product_group[0];
            } else if (datas !== undefined && datas.type == "cg") {
              this.selectedProoductType = response.data.type[0];
              this.selectedProoductGroup = response.data.product_group[0];
              this.selectedProoductSubGroup = response.data.product_subgroup[0];
            }
          }
        })
        .catch();
    },
    customLabelProoduct({ code, title }) {
      return `${code} - ${title}`;
    },
    clearAll(id, type) {
      if (type == "type") {
        this.selectedProoductType = [];
        this.selectedProoductGroup = [];
        this.selectedProoductSubGroup = [];
        this.selectedProoductCG = [];
        this.getAllProduct();
      } else if (type == "group") {
        let datas = { type: "type", code: this.selectedProoductType.code };
        this.selectedProoductGroup = [];
        this.selectedProoductSubGroup = [];
        this.selectedProoductCG = [];
        this.getAllProduct(datas);
      } else if (type == "subgroup") {
        let datas = { type: "group", code: this.selectedProoductGroup.code };
        this.selectedProoductSubGroup = [];
        this.selectedProoductCG = [];
        this.getAllProduct(datas);
      } else if (type == "cg") {
        let datas = {
          type: "subgroup",
          code: this.selectedProoductSubGroup.code
        };
        this.selectedProoductCG = [];
        this.getAllProduct(datas);
      }
    },
    setDataProoduct(selectedOption, id) {
      let datas = { type: id, code: selectedOption.code };
      this.getAllProduct(datas);
    },
    searchProduct() {
      let v_type = this.selectedProoductType.code;
      let v_group = this.selectedProoductGroup.code;
      let v_subgroup = this.selectedProoductSubGroup.code;
      let v_cg = this.selectedProoductCG.code;
      if (
        (v_type == "" || v_type == null) &&
        (v_group == "" || v_group == null) &&
        (v_subgroup == "" || v_subgroup == null) &&
        (v_cg == "" || v_cg == null) &&
        (this.searchProductCode == "" || this.searchProductCode == null) &&
        (this.searchProductName == "" || this.searchProductName == null)
      ) {
        this.showSnackbar = true;
        this.dContent =
          "Please select or fill in the input you want to search.";
      } else {
        let datas = {
          name: this.searchProductName,
          type: v_type,
          group: v_group,
          subgroup: v_subgroup,
          cg: v_cg
        };
        this.getAllProductSearch(datas);
      }
    },
    getAllProductSearch(datas) {
      this.loading = true;
      BookpriceService.searchProduct(
        this.searchProductCode,
        "filter",
        [],
        this.dataToken.code,
        datas,
        this.bookpricegroup,
        this.groupbookcode
      )
        .then(response => {
          if (response) {
            if (response.data.length > 0) {
              this.tableFilterProduct = response.data.sort((a, b) =>
                a.code > b.code ? 1 : -1
              );
            } else {
              this.tableFilterProduct = [];
            }
            this.checkedProductAll = false;
          }
          this.loading = false;
        })
        .catch();
    },
    selectedCheckedAllProduct() {
      this.checkedProduct = [];
      if (!this.checkedProductAll) {
        for (let itemCode in this.tableFilterProduct) {
          this.checkedProduct.push(this.tableFilterProduct[itemCode].code);
        }
      }
    },
    selectedCheckedProduct(code) {
      if (this.checkedProduct.indexOf(code) == -1) {
        this.checkedProduct.push(code);
      } else {
        this.checkedProduct.splice(this.checkedProduct.indexOf(code), 1);
      }

      if (this.checkedProduct.length !== this.tableFilterProduct.length) {
        this.checkedProductAll = false;
      } else {
        this.checkedProductAll = true;
      }
    },
    onClickCancel() {
      this.checkEvent = "cancel";
      this.contentDialog = "Are you sure you want to cancel ?";
      this.showDialogConfirm = true;
    },
    onClickAdd() {
      this.checkEvent = "add";
      this.contentDialog = "Are you sure you want to add ?";
      this.showDialogConfirm = true;
    },
    onClickAddClose() {
      this.checkEvent = "addclose";
      this.contentDialog = "Are you sure you want to add and close ?";
      this.showDialogConfirm = true;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkEvent === "cancel") {
        this.clearData();
        this.$emit("cancel");
      } else if (this.checkEvent === "add") {
        let dataArray = this.toPrepareData();
        this.$emit("add", dataArray);
      } else if (this.checkEvent === "addclose") {
        let dataArray = this.toPrepareData();
        this.clearData();
        this.$emit("addclose", dataArray);
      }
      this.showDialogConfirm = false;
    },
    toPrepareData() {
      let dataPush = [];
      for (let i = 0; i < this.checkedProduct.length; i++) {
        let key = this.tableFilterProduct.findIndex(item => {
          return this.checkedProduct[i] === item.code;
        });

        if (key > -1) {
          dataPush.push(this.tableFilterProduct[key]);
        }
      }
      return dataPush;
    },
    clearData() {
      this.checkedProductAll = false;
      this.checkedProduct = [];
      this.tableFilterProduct = [];
      this.selectedProoductType = [];
      this.selectedProoductGroup = [];
      this.selectedProoductSubGroup = [];
      this.selectedProoductCG = [];
      this.searchProductCode = "";
      this.searchProductName = "";
    }
  }
};
</script>
<style lang="scss">
.bookprice-dialog-filter-product {
  .dialog-content {
    .left-panel {
      width: 40%;
      padding-right: 25px;
      overflow-y: scroll;
      height: calc(85vmin - 135px);

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    .right-panel {
      width: 60%;
      padding: 20px 15px 20px 25px;
      height: calc(85vmin - 135px);
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
        0 1px 1px -2px rgba(0, 0, 0, 0);
      border-radius: 5px;
    }

    .mb10 {
      margin-bottom: 10px;
    }

    .filter-search {
      margin: 0px;
      width: 120px;
      height: 35px;
      color: #ffffff;
      background-color: #3f51b5;
      border-radius: 3px;
      box-shadow: unset;
    }
  }

  .table-filter-product {
    padding: 0;

    .divBodyList {
      height: calc(85vmin - 270px);

      > div .md-icon {
        cursor: text;
      }
    }
  }
}
</style>